import React from 'react';
import styled from 'styled-components';
import Line from './line';
// import { media } from '../design/media';
import GlitchyText from './glitch';
import { FaHeart } from 'react-icons/fa';
import SocialMobile from './social-mobile';
const StyledFooter = styled.div`
  text-align: center;
  margin: 2rem auto;
  font-size: 13.2px;
`;
const StyledLine = styled.div`
  margin: 1rem auto;
`;
const Footer = () => {
  // var d = new Date();
  // var year = d.getFullYear();
  return (
    <StyledFooter>
      <StyledLine>
        <Line
          maxLength="20vh"
          style={{
            stroke: `var(--color-text)`,
            strokeWidth: '2px',
          }}
        />
        <SocialMobile />
      </StyledLine>
      <GlitchyText>made with</GlitchyText> <FaHeart />{' '}
      <GlitchyText>by Subhendu Maji | Copyright 2021</GlitchyText>
    </StyledFooter>
  );
};

export default Footer;
